<template>
    <div class="leave-index" >
        <!-- <myBreadCrumb :urls="JSON.stringify(breadcrumbs)" @createForm="dialog.state=true" :icon="icon"></myBreadCrumb> -->
        <create-dialog v-model="dialog" @CloseDialog="closeHandler" @fetchData="fetchData" @passwordDialog="passwordDialog=true"></create-dialog>

        <v-card v-if="true">
            <v-card-title>
                <v-spacer></v-spacer>
                <!-- <v-btn small color="warning" dark @click="changePasswordDialog=true" class="mx-2">
                    <v-icon small left>mdi-key</v-icon> Thay đổi mk
                </v-btn>
                <v-btn small color="teal darken-4" dark @click="dialog.state=true">
                    <v-icon small left>mdi-upload</v-icon> Upload excel
                </v-btn> -->
                <!-- <create-button @click="dialog.state=true" ></create-button> -->
                <month-picker width="7rem" v-model="month" label="Chọn tháng" outlined dense></month-picker>
                <v-divider vertical class="mx-2"></v-divider>
                
                <!-- menu -->
                <v-menu
                    left
                    bottom offset-y
                >
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn outlined color="success"
                            v-bind="attrs"
                            v-on="on"
                        >
                            Hành động<v-icon>mdi-chevron-down</v-icon>
                        </v-btn>
                    </template>

                    <v-list>
                        <v-list-item @click="dialog.state=true">
                            <v-list-item-icon>
                                <v-icon color="warning">mdi-upload</v-icon>
                            </v-list-item-icon>
                            <v-list-item-title>Import excel 
                            </v-list-item-title>
                        </v-list-item>
                        <v-list-item @click="changePasswordDialog=true">
                            <v-list-item-icon>
                                <v-icon color="warning">mdi-key</v-icon>
                            </v-list-item-icon>
                            <v-list-item-title>Thay đổi mật khẩu </v-list-item-title>
                        </v-list-item>
                        <v-list-item @click="showData">
                            <v-list-item-icon>
                                <v-icon color="warning">mdi-cellphone</v-icon>
                            </v-list-item-icon>
                            <v-list-item-title>Hiển thị dữ liệu </v-list-item-title>
                        </v-list-item>
                        <v-list-item @click="hideData">
                            <v-list-item-icon>
                                <v-icon color="warning">mdi-cellphone-off</v-icon>
                            </v-list-item-icon>
                            <v-list-item-title>Ẩn dữ liệu </v-list-item-title>
                        </v-list-item>
                    </v-list>
                </v-menu>
            </v-card-title>
            <v-data-table height="600px"
            :mobile-breakpoint="0"
            :headers="headers"
            :items="items"
            :loading="isLoading"
            loading-text="Đang tải dữ liệu..."
            >
            
                <template v-slot:[`top`]>
                    <v-row class="mx-1 mb-4">
                        <v-col cols="6" md="4">
                            <v-text-field v-model="filterEmployeeCode" outlined dense label="Tìm kiếu mã NS" hide-details></v-text-field>
                        </v-col>
                        <v-col cols="6" md="4">
                            <v-text-field v-model="filterEmployeeName" outlined dense label="Tìm kiếu tên NS" hide-details></v-text-field>
                        </v-col>
                        <v-col cols="6" md="4">
                            <v-text-field v-model="filterDepartmentName" outlined dense label="Tìm kiếu tên phòng/chi nhánh" hide-details></v-text-field>
                        </v-col>
                    </v-row>
                </template>

                <template v-slot:[`item.actions`]="{ item }">
                    <v-btn small color="primary" @click="detailDialog=true, getItem(item.id)">xem</v-btn>
                </template>
                <template v-slot:[`item.maNS`]="{ item }">
                    <div :class="item.isShow==1?'success--text font-weight-bold':''">{{item.maNS}}</div>
                </template>
                <template v-slot:[`item.ten`]="{ item }">
                    <div :class="item.isShow==1?'success--text font-weight-bold':''">{{item.ten}}</div>
                </template>
                <template v-slot:[`item.chiNhanh`]="{ item }">
                    <div :class="item.isShow==1?'success--text font-weight-bold':''">{{item.chiNhanh}}</div>
                </template>
                <template v-slot:[`item.boPhan`]="{ item }">
                    <div :class="item.isShow==1?'success--text font-weight-bold':''">{{item.boPhan}}</div>
                </template>
                <template v-slot:[`item.chucVu`]="{ item }">
                    <div :class="item.isShow==1?'success--text font-weight-bold':''">{{item.chucVu}}</div>
                </template>
                <!-- <template v-slot:[`item.stk`]="{ item }">
                    <div :class="item.isShow==1?'success--text font-weight-bold':''">{{item.stk}}</div>
                </template>
                <template v-slot:[`item.nganHang`]="{ item }">
                    <div :class="item.isShow==1?'success--text font-weight-bold':''">{{item.nganHang}}</div>
                </template> -->

                <template v-slot:[`item.gcCoBan`]="{ item }">
                    {{formatNumber(item.gcCoBan)}}
                </template>
                <template v-slot:[`item.gcThucTe`]="{ item }">
                    {{formatNumber(item.gcThucTe)}}
                </template>
                <template v-slot:[`item.gcLamThem`]="{ item }">
                    {{formatNumber(item.gcLamThem)}}
                </template>
                <template v-slot:[`item.gcTangCa`]="{ item }">
                    {{formatNumber(item.gcTangCa)}}
                </template>
                <template v-slot:[`item.gcLeTet`]="{ item }">
                    {{formatNumber(item.gcLeTet)}}
                </template>
                <template v-slot:[`item.ktTamUng`]="{ item }">
                    {{formatNumber(item.ktTamUng)}}
                </template>
                <template v-slot:[`item.ktBHXH`]="{ item }">
                    {{formatNumber(item.ktBHXH)}}
                </template>
                <template v-slot:[`item.ktTNCN`]="{ item }">
                    {{formatNumber(item.ktTNCN)}}
                </template>
                <template v-slot:[`item.ktTruyThu`]="{ item }">
                    {{formatNumber(item.ktTruyThu)}}
                </template>
                <template v-slot:[`item.lCoBan`]="{ item }">
                    {{formatNumber(item.lCoBan)}}
                </template>
                <template v-slot:[`item.lThucTe`]="{ item }">
                    {{formatNumber(item.lThucTe)}}
                </template>
                <template v-slot:[`item.lLamThem`]="{ item }">
                    {{formatNumber(item.lLamThem)}}
                </template>
                <template v-slot:[`item.lTangCa`]="{ item }">
                    {{formatNumber(item.lTangCa)}}
                </template>
                <template v-slot:[`item.lLeTet`]="{ item }">
                    {{formatNumber(item.lLeTet)}}
                </template>
                <template v-slot:[`item.pcKhuVuc`]="{ item }">
                    {{formatNumber(item.pcKhuVuc)}}
                </template>
                <template v-slot:[`item.pcDaoTao`]="{ item }">
                    {{formatNumber(item.pcDaoTao)}}
                </template>
                <template v-slot:[`item.pcCongTac`]="{ item }">
                    {{formatNumber(item.pcCongTac)}}
                </template>
                <template v-slot:[`item.thuongQuy`]="{ item }">
                    {{formatNumber(item.thuongQuy)}}
                </template>
                <template v-slot:[`item.thuongTienAn`]="{ item }">
                    {{formatNumber(item.thuongTienAn)}}
                </template>
                <template v-slot:[`item.thuongTruyLanh`]="{ item }">
                    {{formatNumber(item.thuongTruyLanh)}}
                </template>

                <template v-slot:[`item.thucNhan`]="{ item }">
                    {{formatNumber(item.thucNhan)}}
                </template>

                <template v-slot:[`item.tongLuong`]="{ item }">
                    {{formatNumber(item.tongLuong)}}
                </template>

                <template v-slot:[`item.tongKhauTru`]="{ item }">
                    {{formatNumber(item.tongKhauTru)}}
                </template>
            </v-data-table>
        </v-card>
        <!-- ************** DELETE CONFIRMATION *************** -->
        <v-dialog v-model="dialogDelete" max-width="500px">
            <v-card>
                <v-card-title class="headline">Bạn có chắc muốn xoá dữ liệu này?</v-card-title>
                <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="dialogDelete=false">Thoát</v-btn>
                <v-btn color="blue darken-1" text @click="cfmDeleteItem">OK</v-btn>
                <v-spacer></v-spacer>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="passwordDialog" width="300px" persistent>
            <v-card>
                <v-card-title>Mật khẩu CaB
                    <v-spacer></v-spacer>
                    <v-icon @click="passwordDialog=false">mdi-close</v-icon>
                </v-card-title>
                <v-card-text>
                    <v-row>
                        <v-col cols="12">
                            <v-text-field v-model="privatePassword" hide-details="auto" outlined dense label="Mật khẩu" type="password" @keydown.enter.prevent="privateAuth(), privatePassword=''"></v-text-field>
                        </v-col>
                    </v-row>
                </v-card-text>
                <v-card-actions>
                    <v-btn color="primary" @click="privateAuth(), privatePassword=''">OK</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <!-- change pass dialog -->
        <v-dialog v-model="changePasswordDialog" width="350px" persistent>
            <v-card>
                <v-card-title>Thay đổi mật khẩu CaB
                    <v-spacer></v-spacer>
                    <v-icon @click="changePasswordDialog=false">mdi-close</v-icon>
                </v-card-title>
                <v-card-text>
                    <v-row>
                        <v-col cols="12">
                            <v-text-field v-model="privatePasswordChange.password" hide-details="auto" outlined dense label="Mật khẩu" type="password"></v-text-field>
                        </v-col>
                        <v-col cols="12">
                            <v-text-field v-model="privatePasswordChange.passwordConfirmation" hide-details="auto" outlined dense label="Xác nhận mật khẩu" type="password"></v-text-field>
                        </v-col>
                    </v-row>
                </v-card-text>
                <v-card-actions>
                    <v-btn color="primary" @click="changePassword(), privatePasswordChange.password='', privatePasswordChange.passwordConfirmation=''">OK</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="detailDialog">
            <v-card>
                <v-card-title>
                    <v-spacer></v-spacer>
                    <h3>Phiếu lương</h3>
                    <v-spacer></v-spacer>
                    <!-- <v-btn small color="teal darken-4" dark @click="dialog.state=true">
                        <v-icon small left>mdi-upload</v-icon> Upload excel
                    </v-btn> -->
                    <!-- <create-button @click="dialog.state=true" ></create-button> -->
                    <!-- <v-divider vertical class="mx-2"></v-divider> -->
                    <!-- <month-picker width="7rem" v-model="month" label="Chọn tháng" outlined dense></month-picker> -->
                    <!-- <data-filter v-model="params" :filter="filter" @fetchData="fetchData"></data-filter> -->
                </v-card-title>
                <v-card-subtitle class="text-center">
                    <b>Tháng:</b> {{ monthTitle }}
                </v-card-subtitle>
                <v-card-text class="primary--text">
                    <v-row style="max-width: 800px;">
                        <v-col cols="6">
                            <table class="" style="width: 100%;">
                                <tr>
                                    <td class="font-weight-bold">Họ và tên: </td>
                                    <td>{{ item.ten }}</td>
                                </tr>
                                <tr>
                                    <td class="font-weight-bold">Chi nhánh/Phòng ban: </td>
                                    <td>{{ item.chiNhanh }}</td>
                                </tr>
                                <tr>
                                    <td class="font-weight-bold">Chức vụ/Vị trí ban: </td>
                                    <td>{{ item.chucVu }}</td>
                                </tr>
                            </table>
                        </v-col>
                        <v-col cols="6">
                            <table class="" style="width: 100%;">
                                <tr>
                                    <td class="font-weight-bold">Mã NS: </td>
                                    <td>{{ item.maNS }}</td>
                                </tr>
                                <tr>
                                    <td class="font-weight-bold">Bộ phận: </td>
                                    <td>{{ item.boPhan }}</td>
                                </tr>
                                <tr>
                                    <td class="font-weight-bold">Tại ngân hàng: </td>
                                    <td>{{ item.nganHang }}</td>
                                </tr>
                            </table>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12" md="6">
                            <v-simple-table style="border: 1px solid; border-collapse: collapse;">
                                <tbody>
                                    <!-- <tr>
                                        <td class="font-weight-bold">Số giờ công cơ bản</td>
                                        <td>{{ formatNumber(item.gcCoBan + 0.0) }}</td>
                                    </tr>
                                    <tr>
                                        <td class="font-weight-bold">Số giờ công thực tế</td>
                                        <td>{{ formatNumber(item.gcThucTe + 0.0) }}</td>
                                    </tr> -->

                                    <!-- ****  ngay cong *** -->
                                    <tr>
                                        <td class="font-weight-bold">Ngày công chuẩn</td>
                                        <td>{{ formatNumber(item.ncCoBan + 0.0) }}</td>
                                    </tr>
                                    <tr>
                                        <td class="font-weight-bold">Ngày công tính lương</td>
                                        <td>{{ formatNumber(item.ncThucTe + 0.0) }}</td>
                                    </tr>

                                    <tr>
                                        <td class="font-weight-bold">Giờ làm thêm</td>
                                        <td>{{ formatNumber(item.gcLamThem + 0.0) }}</td>
                                    </tr>
                                    <tr>
                                        <td class="font-weight-bold">Giờ tính tăng ca</td>
                                        <td>{{ formatNumber(item.gcTangCa + 0.0) }}</td>
                                    </tr>
                                    <tr>
                                        <td class="font-weight-bold">Giờ lễ/tết</td>
                                        <td>{{ formatNumber(item.gcLeTet + 0.0) }}</td>
                                    </tr>
                                    <tr>
                                        <td class="font-weight-bold orange darken-2 white--text" colspan="2" >Các khoản khấu trừ</td>
                                    </tr>
                                    <tr>
                                        <td class="font-weight-bold">Tạm ứng cơm/lương</td>
                                        <td>{{ formatNumber(item.ktTamUng + 0.0) }}</td>
                                    </tr>
                                    <tr>
                                        <td class="font-weight-bold">BHXH</td>
                                        <td>{{ formatNumber(item.ktBHXH + 0.0) }}</td>
                                    </tr>
                                    <tr>
                                        <td class="font-weight-bold">Thuế TNCN</td>
                                        <td>{{ formatNumber(item.ktTNCN + 0.0) }}</td>
                                    </tr>
                                    <tr>
                                        <td class="font-weight-bold">Truy thu/Thu hồi <br> => Xem mục (*) bên dưới</td>
                                        <td>{{ formatNumber(item.ktTruyThu + 0.0) }}</td>
                                    </tr>
                                    <tr>
                                        <td colspan="2"></td>
                                    </tr>
                                    <tr>
                                        <td colspan="2"></td>
                                    </tr>
                                    <tr>
                                        <td colspan="2"></td>
                                    </tr>
                                    <tr>
                                        <td class="font-weight-bold">
                                            Truy thu Thuế TNCN 2025
                                            (Quyết toán thuế TNCN 2025)</td>
                                        <td>{{ formatNumber(item.truyThu2023 + 0.0) }}</td>
                                    </tr>
                                    <tr>
                                        <td class="font-weight-bold red--text">Tổng khấu trừ (1)</td>
                                        <td class="red--text">{{formatNumber(Number(item.tongKhauTru + 0.0) )}}</td>
                                    </tr>
                                </tbody>
                            </v-simple-table>
                        </v-col>
                        <v-col cols="12" md="6">
                            <v-simple-table style="border: 1px solid; border-collapse: collapse;">
                                <tbody>
                                    <tr>
                                        <td class="font-weight-bold">Lương cơ bản</td>
                                        <td>{{ formatNumber(item.lCoBan + 0.0) }}</td>
                                    </tr>
                                    <tr>
                                        <td class="font-weight-bold">Lương thực tế</td>
                                        <td>{{ formatNumber(item.lThucTe + 0.0) }}</td>
                                    </tr>
                                    <tr>
                                        <td class="font-weight-bold">Lương làm thêm</td>
                                        <td>{{ formatNumber(item.lLamThem + 0.0) }}</td>
                                    </tr>
                                    <tr>
                                        <td class="font-weight-bold">Lương tăng ca</td>
                                        <td>{{ formatNumber(item.lTangCa + 0.0) }}</td>
                                    </tr>
                                    <tr>
                                        <td class="font-weight-bold">Lương Lễ/Tết</td>
                                        <td>{{ formatNumber(item.lLeTet + 0.0) }}</td>
                                    </tr>
                                    <tr>
                                        <td class="font-weight-bold">Phụ cấp khu vực</td>
                                        <td>{{ formatNumber(item.pcKhuVuc + 0.0) }}</td>
                                    </tr>
                                    <tr>
                                        <td class="font-weight-bold">Phụ cấp đào tạo</td>
                                        <td>{{ formatNumber(item.pcDaoTao + 0.0) }}</td>
                                    </tr>
                                    <tr>
                                        <td class="font-weight-bold">Phụ cấp công việc</td>
                                        <td>{{formatNumber(item.pcCongViec + 0.0)}}</td>
                                    </tr>
                                    <tr>
                                        <td class="font-weight-bold">Phụ cấp chuyên môn (DSPT)</td>
                                        <td>{{ formatNumber(item.pcChuyenMon + 0.0) }}</td>
                                    </tr>
                                    <tr>
                                        <td class="font-weight-bold">Tiền ăn giữa ca</td>
                                        <td>{{ formatNumber(item.thuongTienAn + 0.0) }}</td>
                                    </tr>
                                    <tr>
                                        <td class="font-weight-bold">Truy lãnh/Hoàn trả <br> => Xem mục (**) bên dưới</td>
                                        <td>{{ formatNumber(item.thuongTruyLanh + 0.0) }}</td>
                                    </tr>
                                    <tr>
                                        <td class="font-weight-bold">Thưởng bán hàng <br>
                                            => Xem chi tiết ở bên dưới </td>
                                        <td>{{ formatNumber(item.thuongBanHangBanDau + 0.0) }}</td>
                                    </tr>
                                    <tr>
                                        <td class="font-weight-bold">Trợ cấp thôi việc/mất việc</td>
                                        <td>{{ formatNumber(item.thoiViec + 0.0) }}</td>
                                    </tr>

                                    <!-- <tr>
                                        <td class="font-weight-bold">Thưởng lương tháng 13
                                        <p><small>(Xem chi tiết ở dưới)</small></p></td>
                                        <td>{{ formatNumber(item.thuongLuong13 + 0.0) }}</td>
                                    </tr> -->

                                    <tr>
                                        <td class="font-weight-bold">
                                            Hoàn thuế TNCN 2025
                                            (Quyết toán thuế TNCN 2025)</td>
                                        <td>{{ formatNumber(item.hoanThue2023 + 0.0) }}</td>
                                    </tr>
                                    <tr>
                                        <td class="font-weight-bold red--text">Tổng lương (2)</td>
                                        <td class="font-weight-bold red--text">{{ formatNumber(item.tongLuong + 0.0) }}</td>
                                    </tr>
                                    

                                </tbody>
                            </v-simple-table>
                        </v-col>
                    </v-row>
                    <v-card outlined elevation="0" rounded="lg" class="mt-4" style="border: 2px solid black;">
                        <v-card-text>
                            <h2><span class="primary--text font-weight-bold">Lương thực nhận (2)-(1): </span> {{ formatNumber(item.thucNhan + 0.0)}}</h2>
                            <h2><span class="red--text font-weight-bold">Bằng chữ: </span> {{ item.bangChu}}</h2>
                        </v-card-text>
                    </v-card>
                    
                    <v-subheader class=" text--darken-4 font-weight-medium">
                        (*) {{ item.ktTruyThu ? item.ktGhiChuTruyThu : '' }}
                    </v-subheader>
                    
                    <v-subheader class=" text--darken-4 font-weight-medium">
                        (**) {{ item.thuongTruyLanh ? item.ghiChuTruyLanh : '' }}
                    </v-subheader>

                    <v-subheader class="orange--text text--darken-4 font-weight-medium">
                        <i>*Lưu ý: Do tính bảo mật về tiền lương nên Anh/Chị TBP/ASM cung cấp riêng cho từng cá nhân nhận lương. Mỗi cá nhân cam kết không tiết lộ thông tin tiền lương, nếu vi phạm sẽ xử lý theo quy định của Công ty.</i>
                    </v-subheader>
                    
                    <v-row v-if="thisMonth == 1">
                        <v-col cols="12" md="12">
                            <v-subheader class="font-weight-bold red--text text--darken-4">Chi tiết Thưởng lương Tháng 13 năm 2025</v-subheader>
                            
                            <v-simple-table style="border: 1px solid; border-collapse: collapse;">
                                <!-- <tr>
                                    <th>Số cấn trừ thất thoát</th>
                                    <th>Ghi chú</th>
                                </tr> -->
                                <tbody>
                                    <tr>
                                        <td class="font-weight-bold">Trung bình lương 2025</td>
                                        <td>{{ formatNumber(item.trungBinhLuong + 0.0) }}</td>
                                        <td></td>
                                    </tr>
                                    <tr>
                                        <td class="font-weight-bold">Số tháng làm việc thực tế</td>
                                        <td>{{ formatNumber(item.soThangLamViec + 0.0) }}</td>
                                        <td></td>
                                    </tr>
                                    <tr>
                                        <td class="font-weight-bold">Thưởng lương tháng 13 năm 2025</td>
                                        <td>{{ formatNumber(item.thuongLuong13 + 0.0) }}</td>
                                        <td></td>
                                    </tr>
                                </tbody>
                            </v-simple-table>
                        </v-col>
                    </v-row>

                    <v-row v-show="true">
                        <v-col cols="12" md="12" v-if="!isInHidePeriod">
                            <v-subheader class="font-weight-bold red--text text--darken-4">1. Chi tiết khấu trừ thất thoát Tháng {{monthTitleShort}}</v-subheader>
                            
                            <v-simple-table style="border: 1px solid; border-collapse: collapse;">
                                <tr>
                                    <th></th>
                                    <th>Số cấn trừ thất thoát</th>
                                    <th>Ghi chú</th>
                                </tr>
                                <tbody>
                                    <tr>
                                        <td class="font-weight-bold">Thất thoát trong tháng</td>
                                        <td>{{ formatNumber(item.thatThoatTrongThang + 0.0) }}</td>
                                        <td></td>
                                    </tr>
                                    <tr>
                                        <td class="font-weight-bold">Thất thoát ghi nợ tháng trước</td>
                                        <td>{{ formatNumber(item.thatThoatGhiNo + 0.0) }}</td>
                                        <td></td>
                                    </tr>
                                    <tr>
                                        <td class="font-weight-bold">Tổng thất thoát(1):</td>
                                        <td>{{ formatNumber(item.tongThatThoat + 0.0) }}</td>
                                        <td></td>
                                    </tr>
                                </tbody>
                            </v-simple-table>
                        </v-col>
                        <v-col cols="12" md="12">
                            <v-subheader class="font-weight-bold red--text text--darken-4">Chi tiết Thưởng bán hàng Tháng {{ monthTitleShort }}</v-subheader>
                            
                            <v-simple-table style="border: 1px solid; border-collapse: collapse;">
                                <tr>
                                    <th></th>
                                    <th>Số tiền thưởng</th>
                                    <th>Ghi chú</th>
                                </tr>
                                <tbody>
                                    <tr>
                                        <td class="font-weight-bold">Thưởng Doanh thu</td>
                                        <td>{{ formatNumber(item.thuongDoanhThuBanDau + 0.0) }}</td>
                                        <td></td>
                                    </tr>
                                    <tr>
                                        <td class="font-weight-bold">Thưởng GP</td>
                                        <td>{{ formatNumber(item.thuongGp + 0.0) }}</td>
                                        <td></td>
                                    </tr>
                                    <tr v-if="isInHidePeriod">
                                        <td class="font-weight-bold">Thưởng Zalo Pay</td>
                                        <td>{{ formatNumber(item.zalo + 0.0) }}</td>
                                        <td></td>
                                    </tr>
                                    <tr>
                                        <td class="font-weight-bold">Thưởng đơn hàng Online</td>
                                        <td>{{ formatNumber(item.billOnline + 0.0) }}</td>
                                        <td></td>
                                    </tr>
                                    <tr>
                                        <td class="font-weight-bold">Thưởng khác </td>
                                        <td>{{ formatNumber(item.thuongKhac + 0.0) }}</td>
                                        <td><span v-if="thisMonth ==1">Thưởng lương tháng 13 năm {{ year13 }}</span></td>
                                    </tr>
                                    
                                    <tr>
                                        <td class="font-weight-bold"><b>Tổng các khoản thưởng</b> </td>
                                        <td>{{ formatNumber(item.thuongBanHangBanDau + 0.0) }}</td>
                                        <td></td>
                                    </tr>
                                    
                                    <tr v-if="!isInHidePeriod">
                                        <td class="font-weight-bold">Tổng các khoản thưởng sau cấn trừ thất thoát (2)-(1) </td>
                                        <td>{{ formatNumber(item.thuongSauThatThoat + 0.0) }}</td>
                                        <td></td>
                                    </tr>
                                    <tr v-if="!isInHidePeriod">
                                        <td class="font-weight-bold">Thất thoát ghi nợ tháng sau </td>
                                        <td>{{ formatNumber(item.thatThoatGhiNoThangSau + 0.0) }}</td>
                                        <td>{{ item.ghiChuThatThoat }}</td>
                                    </tr>
                                    <!-- <tr>
                                        <td class="font-weight-bold">Thưởng Star list</td>
                                        <td>{{ formatNumber(item.thuongStarListBanDau + 0.0) }}</td>
                                        <td></td>
                                    </tr>
                                    <tr>
                                        <td class="font-weight-bold">Thưởng động lực</td>
                                        <td>{{ formatNumber(item.thuongDongLuc + 0.0) }}</td>
                                        <td></td>
                                    </tr>
                                    <tr>
                                        <td class="font-weight-bold">Thưởng Quý</td>
                                        <td>{{ formatNumber(item.thuongQuy + 0.0) }}</td>
                                        <td></td>
                                    </tr>
                                    <tr>
                                        <td class="font-weight-bold">Thưởng hàng DW</td>
                                        <td>{{ formatNumber(item.thuongDW + 0.0) }}</td>
                                        <td></td>
                                    </tr>
                                    <tr>
                                        <td class="font-weight-bold">Thưởng Top 50 Star list </td>
                                        <td>{{ formatNumber(item.thuongTop50StarList + 0.0) }}</td>
                                        <td></td>
                                    </tr>
                                    <tr>
                                        <td class="font-weight-bold">Thưởng KK bán hàng NCC</td>
                                        <td>{{ formatNumber(item.thuongKkNcc + 0.0) }}</td>
                                        <td></td>
                                    </tr>
                                    <tr>
                                        <td class="font-weight-bold">Thưởng KK bán hàng Private label & Exclusive</td>
                                        <td>{{ formatNumber(item.thuongKkPrivateLabel + 0.0) }}</td>
                                        <td></td>
                                    </tr>
                                    
                                     <tr>
                                        <td class="font-weight-bold">Thưởng KK bán hàng Private label & exclusive (New Product)</td>
                                        <td>{{ formatNumber(item.privateLabelNew + 0.0) }}</td>
                                        <td></td>
                                    </tr> -->
                                    <!-- <tr>
                                        <td class="font-weight-bold">Thưởng đơn hàng Online</td>
                                        <td>{{ formatNumber(item.billOnline + 0.0) }}</td>
                                        <td></td>
                                    </tr>
                                    
                                    <tr>
                                        <td class="font-weight-bold">Thưởng thi đua bán hàng (NCC Đông Á)</td>
                                        <td>{{ formatNumber(item.thuongDongA + 0.0) }}</td>
                                        <td></td>
                                    </tr>
                                    <tr>
                                        <td class="font-weight-bold">Thưởng thi đua bán hàng (NCC Mayoly)</td>
                                        <td>{{ formatNumber(item.thuongMeoly + 0.0) }}</td>
                                        <td></td>
                                    </tr>
                                    <tr>
                                        <td class="font-weight-bold">Thưởng thi đua bán hàng(NCC DHG)</td>
                                        <td>{{ formatNumber(item.thuongDHG + 0.0) }}</td>
                                        <td></td>
                                    </tr>
                                    <tr>
                                        <td class="font-weight-bold">Thưởng thi đua bán hàng(NCC Hisamitsu)</td>
                                        <td>{{ formatNumber(item.thuongHitamitsu + 0.0) }}</td>
                                        <td></td>
                                    </tr>
                                    <tr>
                                        <td class="font-weight-bold">Thưởng thi đua bán hàng(NCC Santen)</td>
                                        <td>{{ formatNumber(item.thuongSanten + 0.0) }}</td>
                                        <td></td>
                                    </tr>
                                    <tr>
                                        <td class="font-weight-bold">Thưởng thi đua bán hàng(NCC Hyphens)</td>
                                        <td>{{ formatNumber(item.thuongHyphens + 0.0) }}</td>
                                        <td></td>
                                    </tr>
                                    <tr>
                                        <td class="font-weight-bold">Thưởng thi đua bán hàng(NCC OPV)</td>
                                        <td>{{ formatNumber(item.thuongOPV + 0.0) }}</td>
                                        <td></td>
                                    </tr>
                                    <tr>
                                        <td class="font-weight-bold">Thưởng thi đua bán hàng(NCC Organon)</td>
                                        <td>{{ formatNumber(item.thuongOrganon + 0.0) }}</td>
                                        <td></td>
                                    </tr>
                                    <tr>
                                        <td class="font-weight-bold">Thưởng thi đua bán hàng(NCC Exeltis)</td>
                                        <td>{{ formatNumber(item.thuongExeltis + 0.0) }}</td>
                                        <td></td>
                                    </tr>

                                    <tr>
                                        <td class="font-weight-bold">Thưởng KK bán hàng cận HSD</td>
                                        <td>{{ formatNumber(item.thuongKkCanDate + 0.0) }}</td>
                                        <td></td>
                                    </tr>
                                     -->
                                </tbody>
                            </v-simple-table>
                        </v-col>
                    </v-row>
                </v-card-text>
                <!-- <v-data-table height="600px"
                :mobile-breakpoint="0"
                :headers="headers"
                :items="items"
                :loading="isLoading"
                loading-text="Đang tải dữ liệu..."
                >
                
                    <template v-slot:[`top`]>
                        <v-row class="mx-1 mb-4">
                            <v-col cols="6" md="4">
                                <v-text-field v-model="search" outlined dense label="Tìm kiếu theo tháng" placeholder="dd/mm/yyyy" hide-details></v-text-field>
                            </v-col>
                        </v-row>
                    </template>

                    <template v-slot:[`item.month`]="{ item }">
                        {{formatDate(item.month)}}
                    </template>

                    <template v-slot:[`item.lCoBan`]="{ item }">
                        {{formatNumber(item.lCoBan)}}
                    </template>

                    <template v-slot:[`item.lThucTe`]="{ item }">
                        {{formatNumber(item.lThucTe)}}
                    </template>

                    <template v-slot:[`item.lLamThem`]="{ item }">
                        {{formatNumber(item.lLamThem)}}
                    </template>
                    
                    <template v-slot:[`item.lTangCa`]="{ item }">
                        {{formatNumber(item.lTangCa)}}
                    </template>

                    <template v-slot:[`item.lLeTet`]="{ item }">
                        {{formatNumber(item.lLeTet)}}
                    </template>

                    <template v-slot:[`item.pcKhuVuc`]="{ item }">
                        {{formatNumber(item.pcKhuVuc)}}
                    </template>

                    <template v-slot:[`item.pcDaoTao`]="{ item }">
                        {{formatNumber(item.pcDaoTao)}}
                    </template>

                    <template v-slot:[`item.pcCongTac`]="{ item }">
                        {{formatNumber(item.pcCongTac)}}
                    </template>

                    <template v-slot:[`item.thuongQuy`]="{ item }">
                        {{formatNumber(item.thuongQuy)}}
                    </template>

                    <template v-slot:[`item.thuongTienAn`]="{ item }">
                        {{formatNumber(item.thuongTienAn)}}
                    </template>

                    <template v-slot:[`item.thuongTruyLanh`]="{ item }">
                        {{formatNumber(item.thuongTruyLanh)}}
                    </template>

                    <template v-slot:[`item.thucNhan`]="{ item }">
                        {{formatNumber(item.thucNhan)}}
                    </template>

                    <template v-slot:[`item.tongLuong`]="{ item }">
                        {{formatNumber(item.tongLuong)}}
                    </template>

                    <template v-slot:[`item.tongKhauTru`]="{ item }">
                        {{formatNumber(item.tongKhauTru)}}
                    </template>
                </v-data-table> -->
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import * as moment from "moment/moment";
import CreateButton from '@/components/Crud/CreateButton';
import http from '@/components/services/http-common';
import Create from './Create';
import DataFilter from '@/components/DataFilter.vue';

export default {
    name: 'Leave',
    components: {
        CreateButton,
        "create-dialog": Create,
        "data-filter": DataFilter
    },
    watch: {
        tableParams: {
            handler (val) {
                this.fetchData();
                this.fetchCity();
            },
            deep: true,
        },
        filters: {
            handler (val) {
                this.tableParams.page=1;
                this.fetchData();
            },
            deep: true,
        },
        month: {
            handler(val)
            {
                this.filters.from = moment(val, "YYYY-MM").startOf("month").format("YYYY-MM-DD");
                this.filters.to = moment(val, "YYYY-MM").endOf("month").format("YYYY-MM-DD");
            }
        }
    },

    computed: {
    
        isInHidePeriod() {
            const routeDate = moment(this.$route.params.id)
            const compareDate = moment('2026-01-01', 'YYYY-MM-DD')

            if (routeDate.isAfter(compareDate)) {
                return true
            }
            return false
        },
        webAllowed() {
            let user = localStorage.getItem("user");
            let webAllowed = localStorage.getItem("WebAllowed");
            user = JSON.parse(user);
            return webAllowed.includes(user.employeeCode);
        },
        params: function() {
            return {...this.tableParams, ...this.filters}
        },
        year13: function() {
            return moment(this.$route.params.id).year() - 1
        },
        thisMonth: function() {
            return moment(this.$route.params.id).month() + 1
        }
    },
    data() {
        return {
            ROOT_URL: "EmployeeSalaryImports/",

            //HEADER DATA
            icon:{
                icon: "mdi-plus-thick",
                to: ""
            },

            //filters
            month: moment().format("YYYY-MM"),
            filters:{
                code:null,
                employeeName:null,
                from: moment().startOf("month").format("YYYY-MM-DD"),
                to: moment().endOf("month").format("YYYY-MM-DD"),
            },
            tableParams: {
                sortBy: [],
                sortDesc: [],
                page: 1,
            },
            rowCount: 0,
            detailDialog: false,
            item: {},

            //TABLE
            filterEmployeeCode:"",
            filterEmployeeName:"",
            filterDepartmentName:"",
            headers: [
                {text: "", value: "actions"},
                {text: "Mã NS", value: "maNS", 
                    filter: value => {
                        if (!this.filterEmployeeCode) return true
            
                        return value.toUpperCase().includes(this.filterEmployeeCode.toUpperCase())
                    },
                },
                {text: "Tên NS", value: "ten", 
                    filter: value => {
                        if (!this.filterEmployeeName) return true
            
                        return value.toUpperCase().includes(this.filterEmployeeName.toUpperCase())
                    },
                },
                {text: "Chức vụ", value: "chucVu"},
                {text: "Chi nhánh/Phòng ban", value: "chiNhanh",
                    filter: value => {
                        if (!this.filterDepartmentName) return true
            
                        return value.toUpperCase().includes(this.filterDepartmentName.toUpperCase())
                    },
                },
                {text: "Bộ phận", value: "boPhan"},
                {text: "STK", value: "stk"},
                {text: "Ngân Hàng", value: "nganHang"},
                {text: "Giờ công cơ bản", value: "gcCoBan"},
                {text: "Giờ công thực tế", value: "gcThucTe"},
                {text: "Giờ công làm thêm", value: "gcLamThem"},
                {text: "Giờ công tăng ca", value: "gcTangCa"},
                {text: "Giờ công lễ tết", value: "gcLeTet"},
                {text: "Khấu trừ tạm ứng", value: "ktTamUng"},
                {text: "Khấu trừ BHXH", value: "ktBHXH"},
                {text: "Khấu trừ TNCN", value: "ktTNCN"},
                {text: "Khấu trừ truy thu", value: "ktTruyThu"},
                {text: "Lương cơ bản", value: "lCoBan"},
                {text: "Lương thực tế", value: "lThucTe"},
                {text: "Lương làm thêm", value: "lLamThem"},
                {text: "Lương tăng ca", value: "lTangCa"},
                {text: "Lương lễ tết", value: "lLeTet"},
                {text: "Phụ cấp khu vực", value: "pcKhuVuc"},
                {text: "Phụ cấp đào tạo", value: "pcDaoTao"},
                {text: "Phụ cấp công tác", value: "pcCongTac"},
                {text: "Phụ cấp chuyên môn", value: "pcChuyenMon"},
                {text: "Thưởng quý", value: "thuongQuy"},
                {text: "Phụ cấp cơm trưa", value: "thuongTienAn"},
                {text: "Thưởng truy lãnh", value: "thuongTruyLanh"},
                {text: "Truy thu thuế 2023", value: "thue2023"},
                {text: "Hoàn thuế 2023", value: "hThue2023"},
                {text: "Tổng lương", value: "tongLuong"},
                {text: "Tổng khấu trừ", value: "tongKhauTru"},
                {text: "Thực nhận", value: "thucNhan"},
                {text: "Bằng chữ", value: "bangChu", width:"350px"},
            ],

            items: [],
            options: {},
            isLoading: true,

            //DIALOG
            dialog: {
                state: false,
                item: undefined,
            },
            dialogDelete: false,
            targetItem: {},

            dialogDetail: false,

            //private auth
            privatePassword: "",
            passwordDialog: false,
            changePasswordDialog:false,

            privatePasswordChange:{
                password:"",
                passwordConfirmation:""
            }
        }
    },

    methods: {
        formatDate(value) {
            return moment(value).format("DD/MM/YYYY");
        },
        formatNumber(value){
            let rValue = this.roundUp(value)
            return rValue.toLocaleString('en-US', { style: 'decimal' });
        },
        roundUp(value){
            return Math.ceil(value * 100) / 100;
        },
        
        status(value) {
            let result = {};
            switch(value) {
                case 0: {
                    result.text = "Chờ duyệt";
                    result.color = "warning"
                    break;
                }
                case 1: {
                    result.text = "Đã duyệt"
                    result.color = "success"
                    break;
                }
                case 2: {
                    result.text = "Từ chối"
                    result.color = "error"
                    break;
                }
                default:{
                    result.text = "unknown"
                    break;
                }
            }
            return result;
        },

        //DATA JS
        fetchData () {
            var JwtString = localStorage.getItem('CaBToken');

            // Check if the data exists
            if (JwtString) {
                return http.get(this.ROOT_URL + "admin/show", {
                    params: {
                        month: this.month,
                        JwtString: JwtString
                    }
                })
                .then(res => {
                    this.items = res.data.data
                    this.isLoading = false;
                }).catch(e => {
                    localStorage.removeItem('CaBToken')
                    this.isLoading = false;
                    this.passwordDialog = true
                })
            } else {
                this.passwordDialog = true
            }
        },
        getItem(id) {
            return http.get(this.ROOT_URL + "admin/detail/"+id, {
            }).then(d => {
                this.item = {...d.data.data}
            })
        },

        showData() {
            var JwtString = localStorage.getItem('CaBToken');
            try {
                return http.get(this.ROOT_URL + "publish", {
                    params: {
                        month: this.month,
                        JwtString: JwtString
                    }
                }).then(()=> this.fetchData())
            } catch(e) {
                alert(e)
            }
        },
        hideData() {
            var JwtString = localStorage.getItem('CaBToken');
            try {
                return http.get(this.ROOT_URL + "unpublish", {
                    params: {
                        month: this.month,
                        JwtString: JwtString
                    }
                }).then(()=> this.fetchData())
            } catch(e) {
                alert(e)
            }
        },

        //DIALOG METHOD
        openDialog() {
            this.params = {
            }
        },
        closeHandler () {
            this.dialog = {state: false, item: undefined}
        },
        editItem (item) {
            this.dialog = {state: true, item: item}
        },
        deleteItem (item) {
            this.dialogDelete = true;
            this.targetItem = item;
        },
        cfmDeleteItem() {
            return http.delete(this.ROOT_URL + "undo/" +this.targetItem.id).then(res => {
                this.fetchData();
                this.dialogDelete = false;
            }).catch(err => {
                switch (err.response.status)
                {
                    case 403:{
                        this.unauthorizeAlert();
                        this.dialogDelete = false;
                        break;
                    }
                    default:
                        break;
                }
            })
        },

        // cab auth
        privateAuth() {
            return http.post("CaBAuthentication/login", {
                password: this.privatePassword
            }).then(res => res.data).then(data => {
                this.passwordDialog = false
                localStorage.setItem('CaBToken', data.data)
                this.fetchData()
            }).catch(e => {
                console.log(e)
            })
        },
        changePassword(){
            var JwtString = localStorage.getItem('CaBToken');
            return http.post("CaBAuthentication/change-password", this.privatePasswordChange, {
                params: {
                    JwtString: JwtString
                }
            }).then(res => res.data).then(data => {
                this.changePasswordDialog = false
                localStorage.removeItem('CaBToken')
                this.fetchData()
                // this.items = []
            }).catch(e => {
                console.log(e)
            })
        }

    },
    
    created() {
        this.fetchData()
    }
}
</script>